import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SessaoExpiradaRouterService } from './sessao-expirada.routing.service';
import { SessaoExpiradaComponent } from './index.component';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([ 
    { path: 'sessaoExpirada', component: SessaoExpiradaComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [SessaoExpiradaRouterService]
})
export class SessaoExpiradaRoutingModule { }
